/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Swipe4Work Admin API
 * OpenAPI spec version: 0.1.1
 */

/**
 * Discriminator for the Swipe4Work.Core.Domains.Links.Entities.LinkItem hierarchy. All values share a single
 * `links.link_item` table (TPH).
 */
export type LinkItemType = typeof LinkItemType[keyof typeof LinkItemType];


export const LinkItemType = {
  MetabaseIframe: 'MetabaseIframe',
  Iframe: 'Iframe',
  Uri: 'Uri',
  InternalLink: 'InternalLink',
} as const;
